export const sum = rows => {
  const expr = rows.map(row => `@${row}`).join('+');
  return `=${expr}`;
};
